import TeacherModel from 'models/TeacherModel';

export default Backbone.Collection.extend({
    model: TeacherModel,
    comparator: 'first_name'
}, {
    type: 'teachers'
});
